import { proxyException } from '../player-setup-communication'
import PlayerSetupFormError from '../player-setup-form-error/player-setup-form-error-tmpl'

const NEW_PLAYER = 'NEW PLAYER'

export default {
  name: 'player-setup-plan-summary',
  inject: [
    '$utils',
    '$api'
  ],
  components: {
    PlayerSetupFormError
  },
  props: {
    isActive: {
      type: [Boolean, null],
      default: false
    },
    nextPage: {
      type: [String, Object, null],
      default: null
    },
    enableSummary: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      invoiceSummary: null,
      errorMessage: ''
    }
  },
  watch: {
    isActive: {
      immediate: true,
      async handler (val) {
        // load invoice summary only if it is enabled
        if (val && this.enableSummary) {
          await this.getInvoiceSummary()
        }
      }
    },
    enableSummary: {
      immediate: true,
      async handler (val) {
        // load invoice summary only if it is enabled
        if (val && this.isActive) {
          await this.getInvoiceSummary()
        }
      }
    }
  },
  computed: {
    filteredInvoiceSummary () {
      if (!this.invoiceSummary) {
        return null
      }

      const { currency } = this.invoiceSummary
      const subTotal = this.invoiceSummary.subtotal / 100
      const vat = this.invoiceSummary.vat / 100
      const vatInPercent = this.invoiceSummary.vatPercent
        ? 100 * this.invoiceSummary.vatPercent
        : Math.round(100 * vat / subTotal * 10) / 10
      const amount = this.invoiceSummary.amount / 100

      // get current plan data
      const invoices = this.invoiceSummary.items.filter((plan) => plan.serial !== NEW_PLAYER)

      // get invoice amount by plan
      const invoicesGroupByPlan = invoices.reduce((acc, item) => {
        const value = Number(item.value) / 100
        acc[item.plan] = (acc[item.plan] || 0) + value
        return acc
      }, {})

      // Add all plan amounts altogether
      const currentPlanSubTotal = Object.values(invoicesGroupByPlan).reduce((total, value) => total + parseInt(value), 0)

      // If there's vat, factor it in the total
      const currentPlanTotal = vatInPercent
        ? currentPlanSubTotal + (currentPlanSubTotal * (vatInPercent / 100))
        : currentPlanSubTotal

      const currentPlanVat = vatInPercent
        ? currentPlanSubTotal * (vatInPercent / 100)
        : 0;

      return {
        subTotal: `${currency} ${subTotal.toFixed(2)}`,
        vatInPercent: `${vatInPercent}%`,
        vat: `${currency} ${vat.toFixed(2)}`,
        total: `${currency} ${amount.toFixed(2)}`,
        newPlayerCount: this.invoiceSummary.items.length,
        currentPlanSummary: {
          playerCount: invoices.length,
          subTotal: `${currency} ${currentPlanSubTotal.toFixed(2)}`,
          vat: `${currency} ${currentPlanVat.toFixed(2)}`,
          total: `${currency} ${currentPlanTotal.toFixed(2)}`
        }
      }
    }
  },
  methods: {
    /**
     * HTTP request to pull invoice summary data
     */
    async loadInvoiceSummaryData () {
      const apiRoute = `/invoice/summary?newPlayer=${NEW_PLAYER}`
      return await proxyException(() => this.$api.get(`${CONFIG.API_BASE_URL}${apiRoute}`))
    },
    /**
     * Set Invoice Summary state or show an error
     */
    async getInvoiceSummary () {
      this.errorMessage = ''

      this.$utils.mainLoader(true)
      const { ok: response, error } = await this.loadInvoiceSummaryData()
      this.$utils.mainLoader(false)

      if (error) {
        this.errorMessage = this.$t('label.PleaseTryAgainOrHeadBackToTheHomepage')
        return
      }

      this.invoiceSummary = response.data
    },
    confirmPlanChange () {
      return { nextPage: this.nextPage }
    }
  }
}
